import { create } from 'zustand';
import { checkUnread } from '../api/NotificationApi';

const useNotificationStore = create((set) => ({
  hasUnread: false,
  isLoading: false,
  
  // 읽지 않은 알림 여부 확인
  checkUnreadNotifications: async () => {
    const state = useNotificationStore.getState();
    
    // 이미 읽지 않은 알림이 있다면 체크하지 않음
    if (state.hasUnread) {
      return;
    }

    try {
      set({ isLoading: true });
      const hasUnread = await checkUnread();
      set({ hasUnread });
    } catch (error) {
      console.error('알림 상태 확인 실패:', error);
    } finally {
      set({ isLoading: false });
    }
  },

  // 알림 상태 초기화 (모두 읽음)
  clearUnreadStatus: () => set({ hasUnread: false }),
}));

export default useNotificationStore; 